import React from 'react';
import { whatWeBuilding } from '../data/mock';

const WhatWeBuilding = () => {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-24 bg-gray-50/50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-8 text-center">
          {whatWeBuilding.title}
        </h2>
        {whatWeBuilding.description.split('\n\n').map((paragraph, index) => (
          <p key={index} className="text-lg text-gray-600 leading-relaxed text-center mb-6 last:mb-0">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};

export default WhatWeBuilding;
